import React from 'react';
import c from './healper.module.css';

/**
 * Shared busy indicator. Validation and prediction both take several seconds,
 * and a line of static text gives no sign that anything is happening - the
 * spinner is the part that says "still working".
 */
const Loading = ({text = 'Loading...', color}) => {
    return (
        <div className={c.loadingContainer} role="status" aria-live="polite">
            <span className={c.spinner} aria-hidden="true"/>
            <span className={c.loadingText} style={color ? {color} : undefined}>{text}</span>
        </div>
    );
};

export default Loading;
